import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { useRpcData } from "@redotech/react-util/rpc-data";
import {
  defaultDropoffFeeUsd,
  DropoffProviderType,
} from "@redotech/redo-return-core-common/dropoff-provider";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";
import { BoxlessDropoffsValue } from "./boxless-dropoffs-settings";

export function useBoxlessDropoffs() {
  const { teamId } = useParams();
  const rpcClient = useRequiredContext(RedoAdminRpcClientContext);

  const {
    value: data,
    error,
    refresh,
  } = useRpcData(rpcClient, "getBoxlessDropoffFees", {
    input: { teamId: teamId ?? "" },
    condition: !!teamId,
  });

  const initial = useMemo<BoxlessDropoffsValue>(
    () =>
      (data?.fees ?? [])
        .filter((fee) => fee.available)
        .map((fee) => ({
          provider: fee.provider,
          fee: String(fee.fee ?? defaultDropoffFeeUsd[fee.provider] ?? 0),
        })),
    [data],
  );

  const updateFee = useHandler(
    async (provider: DropoffProviderType, fee: number, signal: AbortSignal) => {
      if (!teamId) {
        return;
      }
      await rpcClient.updateBoxlessDropoffFee(
        { teamId, provider, fee },
        { signal },
      );
    },
  );

  return { initial, loaded: !!data, error, updateFee, refresh };
}
